export const selectionFilter = "brightness(80.5%)";